(function () {
  'use strict';

  angular.module('app').component('transportationInventoryDetail', transportationInventoryDetail());

  function transportationInventoryDetail() {
    return {
      bindings: {
        item: '=',
        onInventorySaved: '&',
      },
      controller: TransportationInventoryDetailCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-inventories/transportation-inventory-detail/transportation-inventory-detail.component.html',
    };
  }

  TransportationInventoryDetailCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'moment',
    'TransportationInventoryService',
  ];

  function TransportationInventoryDetailCtrl(
    config,
    UtilService,
    $translate,
    $filter,
    moment,
    TransportationInventoryService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    vm.today = moment();

    vm.dateDisplay = config.DATE_DISPLAY;

    // Methods
    vm.saveInventory = saveInventory;

    vm.$onInit = function () {
      vm.item.from = '';
      vm.item.to = '';
      vm.item.total_availability = 0;

      setAvailabilityDates();

      vm.warningMsg = 'UPDATE_TRANSPORTATION_INVENTORY_WARNING';

      if (vm.item.transportation_schedule_id) {
        vm.warningMsg = 'UPDATE_TRANSPORTATION_SCHEDULE_INVENTORY_WARNING';
      }
    };

    function setAvailabilityDates() {
      vm.optionsFrom = {
        singleDatePicker: true,
        showDropdowns: true,
        autoUpdateInput: false,
        minDate: moment(),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'apply.daterangepicker': function () {
            var startDate = angular.copy(vm.item.from);

            vm.optionsTo.minDate = startDate.add(1, 'days');
            if (vm.item.to && vm.item.to < vm.item.from) {
              vm.item.to = vm.optionsTo.minDate;
            }
          },
        },
      };

      vm.optionsTo = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment().add(1, 'days'),
        locale: {
          format: vm.dateDisplay,
        },
      };
    }

    function saveInventory() {
      vm.item.startDay = timeZero(vm.item.from); // check utc
      vm.item.endDay = timeZero(vm.item.to); // ckeck utc

      vm.sendingForm = true;
      TransportationInventoryService.saveTransportationInventoriesByDates(vm.item).then(
        function () {
          vm.onInventorySaved();

          vm.sendingForm = false;
        }
      );
    }

    // Set the time for date object into 00:00:00:00 without timezone offset
    function timeZero(date) {
      var m = date.utcOffset(0);
      m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      return m.toISOString();
    }
  }
})();
